import get from 'lodash/get.js';
import omit from 'lodash/omit.js';
import upperFirst from 'lodash/upperFirst.js';
function maskAuthentication(propNames) {
    return propNames.reduce((result, name) => Object.assign(result, {
        [name]: '[OMITTED]'
    }), {});
}
export function getAuthenticationPropertyNames(authenticationType, formSchema) {
    const authTypeDefinitionName = `authentication${upperFirst(authenticationType)}`;
    const authTypeSchema = formSchema?.definitions?.[authTypeDefinitionName] ?? formSchema?.properties?.authentication;
    const authTypeProperties = authTypeSchema?.properties ?? {};
    return Object.keys(authTypeProperties);
}
function formUsesGenericAuth(formSchema) {
    return get(formSchema, ['properties', 'authentication', 'discriminator', 'propertyName']) === 'type';
}
export function getInitialData(serviceProvider, serviceConfig, { defaultAuthenticationType } = {}) {
    const isNew = !serviceConfig?.id;
    const { authentication, options, ...serviceConfigData } = serviceConfig ?? {};
    const authenticationType = serviceConfig?.authenticationType ?? defaultAuthenticationType ?? 'none';
    const initialData = {
        isNew,
        serviceType: serviceProvider.serviceType,
        provider: serviceProvider.name,
        authenticationType,
        // prevent options.authentication from overwriting authentication
        ...omit(options, ['authentication']),
        ...serviceConfigData
    };
    const formSchema = serviceProvider.getFormSchema?.();
    if (authentication) {
        const authTypePropertyNames = getAuthenticationPropertyNames(authenticationType, formSchema);
        initialData.authentication = {
            ...maskAuthentication(authTypePropertyNames),
            type: authenticationType
        };
    }
    else if (formUsesGenericAuth(formSchema)) {
        initialData.authentication = {
            type: authenticationType
        };
    }
    return initialData;
}
